export default __webpack_public_path__ + "locales/uk-UA/SocialAuthWelcomeDialog.json?hash=e796f7e9e301e31a62fc8edf787c9ad0";